module.exports = __webpack_public_path__ + "static/d0a23c1f5f992c8b1738c0aa6485477f7949e566d5bd54de775691c2c486531b-9f88e1e8e819789dcdf8fe69f669fe2f.png";